import { render, staticRenderFns } from "./ChatBoxTextButton.vue?vue&type=template&id=6caafa76&scoped=true"
import script from "./ChatBoxTextButton.vue?vue&type=script&lang=js"
export * from "./ChatBoxTextButton.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxTextButton.vue?vue&type=style&index=0&id=6caafa76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caafa76",
  null
  
)

export default component.exports